import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { getGenreData } from '../../services/Genres.js';
import GeneralGenres from './GeneralGenres.js';
import Genres from './Genres.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import { useDispatch } from 'react-redux';
import { setPreview } from '../../redux/actions/previewActions.js';

const EditGenresRecord = () => {

  const { alias } = useParams();
  const [genreTitle, setGenreTitle] = useState();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralGenres, subTabs: [
        { id: "basic", title: "Basic", Component: Genres }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getGenreData(alias);

          if (result) {
            setGenreTitle(result?.data?.[0]?.name || result?.data?.[0]?.alias);
          }
        }
      } catch (error) {
        console.error('Error fetching Flip Book data:', error);
      }
    };

    getBasicData();
    dispatch(setPreview(false))
  }, [alias, dispatch]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/genres/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>{_.capitalize(genreTitle)}</Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/genres"} />
    </Stack>
  );
};

export default EditGenresRecord;